module.exports = __webpack_public_path__ + "static/media/nomads-2.1b686c92.png";